import React from "react";
import { Link } from "react-router-dom";

const AuthorItems = ({ authorData }) => {
  const nftCollection = authorData?.nftCollection || [];

  return (
    <div className="de_tab_content">
      <div className="tab-1">
        <div className="row">
          {new Array(8).fill(0).map((_, index) => (
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={index}>
              <div className="nft__item">
                <div className="author_list_pp">
                  <Link to="">
                    <img className="lazy" src={authorData?.authorImage} alt="" />
                    <i className="fa fa-check"></i>
                  </Link>
                </div>
                <div className="nft__item_wrap">
                  <div className="nft__item_extra">
                    <div className="nft__item_buttons">
                      <button>Buy Now</button>
                      <div className="nft__item_share">
                        <h4>Share</h4>
                        <button>
                          <i className="fa fa-facebook fa-lg"></i>
                        </button>
                        <button>
                          <i className="fa fa-twitter fa-lg"></i>
                        </button>
                        <button>
                          <i className="fa fa-envelope fa-lg"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <Link to={`/item-details/${nftCollection[index]?.nftId}`}>
                    <img
                      src={nftCollection[index]?.nftImage}
                      className="lazy nft__item_preview"
                      alt=""
                    />
                  </Link>
                </div>
                <div className="nft__item_info">
                  <Link to={`/item-details/${nftCollection[index]?.nftId}`}>
                    <h4>{nftCollection[index]?.title}</h4>
                  </Link>
                  <div className="nft__item_price">{nftCollection[index]?.price} ETH</div>
                  <div className="nft__item_like">
                    <i className="fa fa-heart"></i>
                    <span>{nftCollection[index]?.likes}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuthorItems;
